import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AboutComponent } from './about/about.component';
import { ContactComponent } from './contact/contact.component';

export const routes: Routes = [
  {
    path: '',
    title: 'Home',
    component: HomeComponent
    //canActivate: [NavPanelGuardService, NotAuthGuardService]
  },  // Strona główna
  {
    path: 'about',
    title: 'O Nas',
    component: AboutComponent
  },  // Strona "O nas"
  {
    path: 'kontakt',
    title: 'Kontakt',
    component: ContactComponent
  },  // Strona "Kontakt"
  {path: '**', redirectTo: ''}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule { }
